export const ADJUST_PRICE_REASONS = [
  { value: 'Customer Service Issue' },
  { value: 'Price Correction' },
  { value: 'Catalog Price Correction' },
  { value: 'Exchange Match' },
];

export const ADJUST_PRICE_TYPES = {
  ITEM_PRICE: 'Item Price',
  DOLLAR_OFF: 'Dollar Off',
  PERCENT_OFF: 'Percent Off',
};

export const ADJUST_PRICE_TABLE_HEADER = {
  PRODUCT_DETAILS: { KEY: 'productDetails', HEADER: 'Product Details' },
  ITEM_PRICE: { KEY: 'itemPrice', HEADER: 'Item Price' },
  TOTAL_PRICE: { KEY: 'totalPrice', HEADER: 'Total Price' },
  REASONS: { KEY: 'reasons', HEADER: 'Reasons' },
};

export const CANCEL_ORDER_EVENT_TYPES = {
  ENTIRE_ORDER: 'RequestCancelEntireOrder',
  LINE_ITEM: 'RequestCancelLines',
  HOLD_ORDER: 'RequestHold',
  RELEASE_ORDER: 'RequestRelease',
};
export const CANCEL_ORDER_MESSAGE = {
  OPREATOR_CHANGE: 'operatorChange',
  CHANGE_MIND: 'changedMind',
  BACKORDER: 'backorder',
};

export const DEAFULT_ORDER_EVENT_MESSAGE = {
  OPERATOR_GENERIC: 'Operator-Generic',
};

export const minimumAdjustLimit = 1000;
export const CART_STATE_ACTIVE = 'Active';
